import React, { useState } from "react";
import { HTTP } from "../../api/http-common";
import { useNavigate,Link } from "react-router-dom";
import { isValidEmail } from '../../component/common';
import { Eye, EyeOff } from "lucide-react";
import Swal from 'sweetalert2'
import { useGlobalContext } from "./../../component/GlobalContext";
import ReCAPTCHA from "react-google-recaptcha";

function Member() {
    const [captchaValue, setCaptchaValue] = useState(null);
    const { usermailToVerify,setUsermailToVerify } = useGlobalContext();
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState("");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastName, setLastName] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [cpassword, setCPassword] = useState("");
    const [passwordShow, setPasswordShow] = useState(false);
    const [cpasswordShow, setcPasswordShow] = useState(false);
    
    const resetValidationErrors = () => {
        setFirstNameError('');
        setLastNameError('');
        setEmailError('');
        setPasswordError('');
    };
    const hideShowPass = () => {
        setPasswordShow(!passwordShow);
     }
     const hideShowcPass = () => {
        setcPasswordShow(!cpasswordShow);
     }
     
  
    const validateField = () => {
      resetValidationErrors();

      let checked = true;
        if (firstName === '') {
            setFirstNameError('Please enter first Name');
            if (checked) {
                checked = false;
            }
        } else if (firstName.length < 3) {
            setFirstNameError("Please enter minimum 3 characters");
            if (checked) {
                checked = false;
            }
        } else if (firstName.length > 100) {
            setFirstNameError("Max character limit is 100");
            if (checked) {
                checked = false;
            }
        }

        if (lastName === '') {
            setLastNameError('Please enter last Name');
            if (checked) {
                checked = false;
            }
        } else if (lastName.length < 3) {
            setLastNameError("Please enter minimum 3 characters");
            if (checked) {
                checked = false;
            }
        } else if (lastName.length > 100) {
            setLastNameError("Max character limit is 100");
            if (checked) {
                checked = false;
            }
        }
    
        if (email === '') {
            setEmailError('Please enter email address');
            if (checked) {
                checked = false;
            }
        } 
        else if (!isValidEmail(email)) {
            setEmailError('Invalid email.');
            if (checked) {
                checked = false;
            }
        }else if (email.length > 100) {
            setEmailError("Max character limit is 100");
            if (checked) {
                checked = false;
            }
        }
        
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#&?])[A-Za-z\d!@#&?]{8,64}$/;
        
        console.log(passwordRegex.test(password))
        let errorMessage = '';
        if (password === '') {
            setPasswordError('Please enter password');
            if (checked) {
                checked = false;
            }
        }
        if (password.length < 5) {
            setPasswordError("Please enter minimum 5 characters");
            if (checked) {
                checked = false;
            }
        }
        // else if (!passwordRegex.test(password)) {
        //     errorMessage = `Password must:
        //     - Be 8-64 characters long
        //     - Include both uppercase and lowercase letters
        //     - Contain both letters and numbers
        //     - Include at least one special character (e.g., ! @ # & ?)`;
        //     setPasswordError(errorMessage);
        //     if (checked) {
        //         checked = false;
        //     }
        // }
        if (cpassword === '') {
            setPasswordError('Please enter confirm password');
            if (checked) {
                checked = false;
            }
        }
        if (password !== cpassword) {
            setPasswordError('Please confirm password');
            if (checked) {
                checked = false;
            }
        }
  
      return checked;
    };
    const handleSubmit = async () => {
        
        if (validateField()) {
            if (!captchaValue) {
                alert("Please verify reCAPTCHA");
                return;
            }
          try {
            // setIsLoading(true);
            // let config = {
            //   headers: { "Content-Type": "application/json", token: access_token },
            // };
    
            let fields = {
              first_name: firstName,
              last_name: lastName,
              email: email,
              password: password,
              confirm_password: password,
              
            };
    
            await HTTP.put(
              "/user/member/register",
              fields,
              // config
            )
              .then(async (response) => {
                if (response.status === 200) {
                    Swal.fire({
                        title: "Registered successfully!",
                        text: "Please verify your email before login",
                        icon: "success"
                    });
                    localStorage.setItem('registered_first_name',firstName);
                    localStorage.setItem('registered_last_name',lastName);
                    localStorage.setItem('registered_email',email);
                    setUsermailToVerify(email);
                    navigate('/verify');
                }
              })
              .catch((error) => {
                if (error.response.status === 406) {
                    resetValidationErrors();
                    setPasswordError(error.response.data.detail);
                }
                if (error.response.status === 400) {
                    Swal.fire({
                        title: 'Error!',
                        text: 'You are already registered!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                      })
                }
                // setError(error);
                // setRerenderFlag(true);
                // loadAaMasterData();
                // resetValidationErrors();
              });
    
            // setIsLoading(false);
          } catch (error) {
            // setError(error);
            // setRerenderFlag(true);
            // setIsLoading(false);
          }
        }
      };
  return (
    <>
        <div
            className="rounded-xl border bg-card text-card-foreground w-full p-8 shadow-sm max-w-[450px] min-h-[450px] my-4"
            // style={{ maxHeight: "580px", height: "100%", overflow: "scroll" }}
            >
            <div className="flex gap-6 mb-6 mt-4">
                <button className="text-2xl font-semibold">Member's Registeration</button>
            </div>
            <div className=" gap-8">
                <div className=" ">
                {/* First Name */}
                <div className=" relative space-y-1 my-3">
                <div className="relative space-y-1">
                    <input
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                    placeholder=" "
                    name="firstName"
                    value={firstName}
                    onChange={(e) => {
                        setFirstName(e.target.value);
                      }}
                    />
                </div>
                <label
                    className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                >
                    First Name
                </label>
                {firstNameError && <span className="text-sm text-red-500">{firstNameError}</span>}
                </div>
                {/* Last Name */}
                <div className=" relative space-y-1 my-4">
                <div className="relative space-y-1">
                    <input
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                    placeholder=" "
                    name="lastName"
                    value={lastName}
                    onChange={(e) => {
                        setLastName(e.target.value);
                      }}
                    />
                </div>
                <label
                    className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                >
                    Last Name
                </label>
                {lastNameError && <span className="text-sm text-red-500">{lastNameError}</span>}
                </div>
                </div>
                {/* Email */}
                <div className="relative my-3 space-y-1">
                <div className="relative space-y-1">
                    <input
                    type="email"
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                    placeholder=" "
                    name="email"
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                </div>
                <label
                    className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                >
                    Email
                </label>
                {emailError && <span className="text-sm text-red-500">{emailError}</span>}
                </div>
                {/* Password */}
                <div className="relative my-3 space-y-1">
                <div className="relative space-y-1">
                    <input
                    type={passwordShow ? "text" : "password"}
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                    placeholder=" "
                    name="password"
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />
                    <button
                    type="button"
                    className="absolute right-0 bottom-2 text-gray-400"
                    onClick={hideShowPass}
                    >
                        {passwordShow ? <EyeOff className="mr-2 h-4 w-4" /> : <Eye className="mr-2 h-4 w-4" />}
                    </button>
                </div>
                <label
                    className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                >
                    Password
                </label>
                {passwordError && <span className="text-sm text-red-500">{passwordError}</span>}
                </div>
                {/* Confirm Password */}
                <div className="relative my-3 space-y-1">
                <div className="relative space-y-1">
                    <input
                    type={cpasswordShow ? "text" : "password"}
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                    placeholder=" "
                    name="confirm_password"
                    value={cpassword}
                    onChange={(e) => {
                        setCPassword(e.target.value);
                      }}
                    />
                    <button
                    type="button"
                    className="absolute right-0 bottom-2 text-gray-400"
                    onClick={hideShowcPass}
                    >
                    {cpasswordShow ? <EyeOff className="mr-2 h-4 w-4" /> : <Eye className="mr-2 h-4 w-4" />}
                    </button>
                </div>
                <label
                    className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                >
                    Confirm Password
                </label>
                </div>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={(value) => setCaptchaValue(value)}
                />
                {/* Submit Button */}
                <button
                className="my-4 inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 shadow px-4 py-2 w-full h-8 bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg  login-page-button-wrapper"
                type="submit"
                onClick={handleSubmit}
                >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-user mr-2 h-5 w-5"
                >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Register
                </button>
                {/* Sign In */}
                <Link
                to="/login"
                className="text-gray-500 hover:text-gray-700 text-sm inline-flex items-center "
                >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-log-in mr-2 h-4 w-4"
                >
                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                    <polyline points="10 17 15 12 10 7"></polyline>
                    <line x1="15" x2="3" y1="12" y2="12"></line>
                </svg>
                
                Sign In
                </Link>
            </div>
        </div>

    </>
  )
}

export default Member